<template>
  <section class="md:flex mb-12 items-start">
    <header
      class="w-full md:w-1/3 md:sticky md:pr-12 mb-6 md:mb-12"
      style="top: 5rem"
    >
      <h1 class="text-2xl leading-tight mb-6">
        {{ fundingPot.name }}
      </h1>
      <h2 class="text-2xs uppercase text-grey-700 tracking-wide leading-none">
        Funding Pot
      </h2>
      <p class="text-2xl text-secondary-800">
        {{ potTotal }}
      </p>
      <ul class="mt-2 list-reset text-base mt-6">
        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.show', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Edit
          </a>
        </li>
        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.competitions.index', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Competitions
          </a>
        </li>

        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.applications.index', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Applications
          </a>
        </li>
        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.grading.index', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Assessments/Grading
          </a>
        </li>
        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.projects.index', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Projects
          </a>
        </li>
        <li class="mb-1">
          <icon
            icon="cheveron-right-circle"
            class="icons-secondary w-4 h-4 mr-1 align-text-bottom"
          />
          <a
            :href="route('wave.claims.index', fundingPot.id)"
            class="text-secondary-700 no-underline hover:underline hover:text-secondary-700"
          >
            Claims
          </a>
        </li>
        <li class="mb-1">
          <icon
            icon="close-circle"
            class="icons-negative w-4 h-4 mr-1 align-text-bottom"
          />
          <button
            type="button"
            class="text-negative-700 no-underline hover:underline hover:text-negative-700 text-left"
          >
            Delete
          </button>
        </li>
      </ul>
    </header>
    <div class="flex-1">
      <admin-dashboard-funding-pot-competition
        v-for="competition in fundingPot.competitions"
        :key="competition.uuid"
        :competition="competition"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "AdminDashboardFundingPot",
  props: {
    fundingPot: {
      type: Object,
      required: true
    }
  },
  computed: {
    potTotal() {
      if (!this.fundingPot.amount) return "TBA";
      return this.fundingPot.amount.toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP"
      });
    }
  }
};
</script>
